import React from 'react';
import QRCode from 'react-qr-code';

/**
 * QR по otpauth:// — для сканирования камерой аутентификатора с телефона.
 * Всегда показываем, когда есть ссылка (раньше скрывали на узких экранах).
 * @param {'dark'|'light'} variant — dark: тёмный фон; light — форма входа на белом фоне
 */
export default function TotpSetupQrBlock({
  value,
  size = 220,
  caption,
  variant = 'dark',
}) {
  if (!value) return null;

  const text =
    caption ||
    'Откройте Google Authenticator → «+» → «Сканировать QR-код» и наведите камеру на код ниже.';

  const isLight = variant === 'light';
  const qrSize = Math.max(160, Math.min(Number(size) || 220, 280));

  return (
    <div
      style={{
        marginTop: 8,
        marginBottom: 8,
        padding: 16,
        borderRadius: 14,
        background: isLight ? '#f0f4f8' : 'rgba(15, 23, 42, 0.45)',
        border: isLight ? '1px solid #dfe6e9' : '1px solid rgba(56, 189, 248, 0.35)',
        textAlign: 'center',
      }}
    >
      <p
        style={{
          margin: '0 0 14px 0',
          fontSize: 14,
          lineHeight: 1.45,
          fontWeight: 600,
          color: isLight ? '#2d3436' : '#e2e8f0',
        }}
      >
        QR-код для Google Authenticator
      </p>
      <p
        style={{
          margin: '0 0 14px 0',
          fontSize: 13,
          lineHeight: 1.45,
          color: isLight ? '#636e72' : '#94a3b8',
        }}
      >
        {text}
      </p>
      <div
        style={{
          display: 'inline-block',
          padding: 14,
          background: '#ffffff',
          borderRadius: 14,
          lineHeight: 0,
          boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        }}
      >
        <QRCode
          value={String(value)}
          size={qrSize}
          level="M"
          fgColor="#0f172a"
          bgColor="#ffffff"
          style={{ display: 'block', width: qrSize, height: qrSize, maxWidth: '100%' }}
        />
      </div>
    </div>
  );
}
